// SpacetoCo booking strategy (Sandy Cape Recreation Park).
//
// `site.reserveUrl` is the unit's own page (/space/<slug>). The stay goes on
// as `datetime`, a URL-encoded JSON pair of check-in and check-out: the
// page's "Booking date" shows the stay and lists the unit only if it is
// free, and one click on Start booking opens the form with both dates
// filled.
//
// The dates are sent as local noon ("2026-10-06T12:00:00"). The page reads
// a date-only value or a UTC instant as UTC midnight and turns it into the
// browser's local day, which lands a day early west of UTC (checked in
// America/Los_Angeles). Local noon read right in Perth, Sydney, London and
// Los Angeles. `startBooking=true&bookingSpaceId=` opens the form directly
// only at phone width and drops the dates, so it is not emitted.

import { format } from "date-fns";
import { resolveCheckout } from "./_context.js";

function localNoon(date) {
  return `${format(date, "yyyy-MM-dd")}T12:00:00`;
}

export default {
  buildBookingUrl(ctx) {
    const { site, arrivalDate } = ctx;
    if (!arrivalDate) return site.reserveUrl;
    const checkout = resolveCheckout(ctx);
    const url = new URL(site.reserveUrl);
    url.searchParams.set(
      "datetime",
      JSON.stringify([localNoon(arrivalDate), localNoon(checkout)]),
    );
    return url.toString();
  },

  // The facility's area page (facility.extraAttributes.areaUrl): the Main
  // Campground's list of all 108 sites, or a bush area's own page.
  buildPreviewUrl(site, facility) {
    return facility?.extraAttributes?.areaUrl ?? site.reserveUrl;
  },

  describeBookingInputs() {
    return {
      inputs: {
        arrivalDate: {
          status: "required",
          notes:
            'Encoded as the first element of &datetime=["<yyyy-MM-dd>T12:00:00", …].',
        },
        departureDate: {
          status: "required",
          notes:
            "The second element of &datetime; resolved from arrival + minStayLength when not supplied.",
        },
        ref: {
          status: "ignored",
          notes: "The unit is the page itself (site.reserveUrl).",
        },
        partySize: {
          status: "ignored",
          defaultValue: 1,
          notes:
            "The form asks for no guest count on a numbered site; a bush area asks for vehicles and defaults to 1.",
        },
      },
    };
  },
};
